import { typeStyleFor } from "./buildingStyle";
import { LAYERS, BUILDING_PANEL } from "./theme";
const PANEL_WIDTH = 210;
let dom = null;
// The company currently rendered — content is only rebuilt when this changes,
// so per-pointermove calls just reposition the panel.
let currentCompany = null;
let panelHeight = 120;
// The panel skeleton is static; only text, colours, and section visibility change
// per company. User-provided strings are assigned via textContent (no escaping needed).
function getDom() {
    if (dom)
        return dom;
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.buildingTooltip};
    pointer-events: none;
    width: ${PANEL_WIDTH}px;
    display: none;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background: ${BUILDING_PANEL.background};
    border: 1px solid ${BUILDING_PANEL.border};
    border-radius: 6px;
    box-shadow: 0 6px 28px rgba(0,0,0,0.75), inset 0 1px 0 rgba(255,255,255,0.04);
  `;
    const header = document.createElement("div");
    header.style.cssText = `
    border-bottom: 1px solid ${BUILDING_PANEL.divider};
    padding: 7px 12px 6px;
    display: flex;
    align-items: center;
    gap: 6px;
  `;
    const typeDot = document.createElement("span");
    typeDot.style.cssText = `
    display: inline-block;
    width: 7px; height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
  `;
    const typeLabel = document.createElement("span");
    typeLabel.style.cssText = `
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  `;
    header.append(typeDot, typeLabel);
    const body = document.createElement("div");
    body.style.cssText = "padding: 9px 12px 10px;";
    const title = document.createElement("div");
    title.style.cssText = `
    color: ${BUILDING_PANEL.title};
    font-size: 13px;
    font-weight: 600;
    line-height: 1.25;
    margin-bottom: 5px;
  `;
    const description = document.createElement("div");
    description.style.cssText = `
    color: ${BUILDING_PANEL.description};
    font-size: 11px;
    line-height: 1.4;
    margin-bottom: 6px;
  `;
    const owner = document.createElement("div");
    owner.style.cssText = `
    color: ${BUILDING_PANEL.owner};
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 4px;
  `;
    owner.innerHTML = `
    <svg width="10" height="10" viewBox="0 0 12 12" fill="none" style="flex-shrink:0">
      <circle cx="6" cy="4" r="2.5" stroke="${BUILDING_PANEL.owner}" stroke-width="1.2"/>
      <path d="M2 11c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="${BUILDING_PANEL.owner}" stroke-width="1.2" stroke-linecap="round"/>
    </svg>
  `;
    const ownerName = document.createElement("span");
    owner.appendChild(ownerName);
    const visitHint = document.createElement("div");
    visitHint.style.cssText = `
    color: ${BUILDING_PANEL.accent};
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 3px;
    margin-top: 8px;
  `;
    const destroyHint = document.createElement("div");
    destroyHint.style.cssText = `
    color: ${BUILDING_PANEL.danger};
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-top: 8px;
  `;
    destroyHint.textContent = "Tippen zum Abreißen";
    body.append(title, description, owner, visitHint, destroyHint);
    panel.append(header, body);
    document.body.appendChild(panel);
    dom = {
        panel,
        typeDot,
        typeLabel,
        title,
        description,
        owner,
        ownerName,
        visitHint,
        destroyHint,
    };
    return dom;
}
function renderCompany(d, company, currentUserId) {
    const style = typeStyleFor(company.kind, company.companyType, company.specialType);
    d.typeDot.style.background = style.color;
    d.typeLabel.style.color = style.color;
    d.typeLabel.textContent = style.label;
    d.title.textContent = company.title;
    d.description.textContent = company.description;
    d.description.style.display = company.description ? "" : "none";
    d.ownerName.textContent = company.ownerName ?? "";
    d.owner.style.display = company.ownerName ? "" : "none";
    // Click destroys when both would apply (an owned manual company has a real link) — Shift+Click
    // opens the link instead. See GameScene.ts's runAction for the matching logic.
    const canDestroy = !!currentUserId &&
        company.ownerId === currentUserId &&
        (company.kind === "special" ||
            (company.kind === "company" && company.source === "manual"));
    d.destroyHint.style.display = canDestroy ? "" : "none";
    d.visitHint.style.display = company.linkUrl ? "" : "none";
    d.visitHint.innerHTML = canDestroy
        ? "<span>Umschalt+Klick: Besuchen</span>"
        : '<span>Besuchen</span><span style="font-size:11px;">→</span>';
}
export function showBuildingTooltip(x, y, company, currentUserId) {
    const d = getDom();
    const contentChanged = company !== currentCompany;
    if (contentChanged) {
        renderCompany(d, company, currentUserId);
        currentCompany = company;
    }
    d.panel.style.display = "block";
    if (contentChanged) {
        // Measure once per company, not on every pointermove.
        panelHeight = d.panel.offsetHeight || panelHeight;
    }
    // Position: offset right + below cursor, clamp to viewport
    const margin = 10;
    const left = Math.min(x + 16, window.innerWidth - PANEL_WIDTH - margin);
    const top = Math.max(Math.min(y - 10, window.innerHeight - panelHeight - margin), margin);
    d.panel.style.left = `${left}px`;
    d.panel.style.top = `${top}px`;
}
export function hideBuildingTooltip() {
    if (dom) {
        dom.panel.style.display = "none";
        currentCompany = null;
    }
}
